/**
 * assets/bundle-upsell.js
 *
 * Handles the "Add Bundle to Cart" button rendered by snippets/bundle-upsell.liquid.
 * Adds every product variant listed in the custom.bundle metafield in a
 * single /cart/add.js request (the current PDP product is NOT auto-added —
 * it must be included in the metafield itself if it belongs in the bundle),
 * then opens/refreshes Dawn's cart drawer. Falls back to /cart if no drawer
 * is found on the page.
 *
 * NOTE: this file does NOT tag items with any bundle property. Grouping in
 * the cart drawer is now done dynamically (see the cart-drawer tbody file)
 * by matching current cart contents against custom.bundle* metafields at
 * render time — so it works the same whether items came from this widget
 * or a plain PDP "Add to Cart", added together or separately.
 */
(function () {
  function initBundleUpsell(root) {
    console.log('[bundle-upsell] initBundleUpsell called on:', root);

    // Idempotency guard: if facets:updated (or anything else) re-runs init()
    // on a root that's already wired up, skip it — otherwise the button ends
    // up with 2+ click listeners and every click fires /cart/add.js twice,
    // which is what causes the "extra quantity" / stale-drawer symptoms.
    if (root.dataset.bundleUpsellBound === 'true') {
      console.log('[bundle-upsell] SKIPPED — already bound:', root);
      return;
    }
    root.dataset.bundleUpsellBound = 'true';

    var btn = root.querySelector('[data-bundle-atc]');
    if (!btn) {
      console.log('[bundle-upsell] no [data-bundle-atc] button found in root:', root);
      return;
    }

    console.log('[bundle-upsell] binding click listener to button:', btn);

    var errorEl = root.querySelector('[data-bundle-error]');
    var bpInputs = root.querySelectorAll('[data-bp-variant-id]');

    btn.addEventListener('click', handleActivate);
    // Anchors trigger "click" on Enter automatically, but NOT on Space like
    // real buttons do — add that manually since role="button" implies it.
    btn.addEventListener('keydown', function (evt) {
      if (evt.code === 'Space' || evt.key === ' ') {
        evt.preventDefault();
        handleActivate(evt);
      }
    });

    function handleActivate(evt) {
      window.__bundleUpsellCallCount = (window.__bundleUpsellCallCount || 0) + 1;
      console.log(
        '[bundle-upsell] handleActivate FIRED — call #' + window.__bundleUpsellCallCount,
        'event type:', evt.type,
        'target:', evt.target
      );

      // Belt-and-suspenders: stop this from bubbling up into a parent
      // <form>/<product-form> in case something up the tree listens for
      // clicks/submits at that level.
      evt.preventDefault();
      evt.stopPropagation();

      if (btn.getAttribute('aria-disabled') === 'true') {
        console.log('[bundle-upsell] IGNORED — button is aria-disabled (already in flight)');
        return;
      }

      setLoading(true);
      hideError();

      var items = [];

      // No property tagging needed anymore — the cart drawer now does
      // DYNAMIC bundle detection (matches cart contents against
      // custom.bundle* metafield definitions at render time), so it
      // doesn't matter whether these variants were added here or
      // separately from their own PDPs; they'll group correctly either way.
      bpInputs.forEach(function (input) {
        var id = input.value;
        if (id) {
          items.push({ id: parseInt(id, 10), quantity: 1 });
        }
      });

      console.log(
        '[bundle-upsell] variant IDs being sent:',
        items.map(function (i) { return i.id; }).join(', ')
      );

      // Safety net: if the custom.bundle metafield ever ends up with the
      // same variant listed twice, Shopify will silently merge them into
      // one cart line with qty 2 instead of two distinct lines. Catch that
      // here with a loud warning instead of letting it ship a wrong cart.
      var uniqueIds = items.map(function (i) { return i.id; }).filter(function (id, idx, arr) {
        return arr.indexOf(id) === idx;
      });
      if (uniqueIds.length !== items.length) {
        console.warn('[bundle-upsell] DUPLICATE variant ID detected in custom.bundle — check the metafield on this product:', items.map(function (i) { return i.id; }));
        setLoading(false);
        showError('This bundle is misconfigured (duplicate product). Please contact support.');
        return;
      }

      if (items.length === 0) {
        setLoading(false);
        showError('Nothing to add — please refresh the page.');
        return;
      }

      var cartAddUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + 'cart/add.js'
        : '/cart/add.js';

      fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: items,
          // Ask Shopify to render these sections server-side in the same
          // response, exactly like Dawn's product-form.js does — this is
          // what lets us hand the result straight to CartDrawer.renderContents().
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname
        })
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) {
              // Shopify returns { description, message } on error (e.g. sold out mid-request)
              throw new Error(data.description || data.message || 'Could not add bundle to cart.');
            }
            return data;
          });
        })
        .then(function (data) {
          console.log(
            '[bundle-upsell] /cart/add.js returned',
            data.items.length,
            'line item(s):',
            data.items.map(function (i) { return i.variant_id + ' (qty ' + i.quantity + ')'; }).join(', ')
          );
          refreshCart(data);
          setLoading(false);
        })
        .catch(function (err) {
          console.log('[bundle-upsell] /cart/add.js ERROR:', err.message);
          setLoading(false);
          showError(err.message);
        });
    }

    function setLoading(isLoading) {
      // <a> has no native disabled state, so fake it with aria-disabled + a
      // class (CSS should set pointer-events: none on .is-loading).
      btn.setAttribute('aria-disabled', isLoading ? 'true' : 'false');
      btn.classList.toggle('is-loading', isLoading);
      var label = btn.querySelector('.btn-label');
      var spinner = btn.querySelector('.btn-spinner');
      if (label) label.hidden = isLoading;
      if (spinner) spinner.hidden = !isLoading;
    }

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = false;
    }

    function hideError() {
      if (!errorEl) return;
      errorEl.hidden = true;
      errorEl.textContent = '';
    }
  }

  /**
   * Opens Dawn's <cart-drawer> with the freshly-added bundle already in it.
   * `data` is the JSON response from /cart/add.js (called with sections +
   * sections_url above), so it already contains rendered HTML for
   * 'cart-drawer' and 'cart-icon-bubble' — no extra fetch needed.
   */
  function refreshCart(data) {
    console.log('[bundle-upsell] refreshCart() called with sections:', data && data.sections ? Object.keys(data.sections) : data);

    var drawer = document.querySelector('cart-drawer');

    if (drawer && typeof drawer.renderContents === 'function' && data && data.sections) {
      // Dawn renders <cart-drawer class="drawer is-empty" ...> server-side
      // when the cart starts empty. renderContents() only clears is-empty
      // off the INNER .drawer__inner node, not the outer <cart-drawer>
      // element itself — so on a first add from an empty cart, open() still
      // thinks it should focus-trap the (now-removed) empty-state markup
      // and throws "Cannot read properties of null (reading querySelectorAll")
      // in trapFocus. Clearing it here before renderContents() runs avoids that.
      if (drawer.classList.contains('is-empty')) {
        console.log('[bundle-upsell] clearing stale is-empty class on <cart-drawer>');
        drawer.classList.remove('is-empty');
      }

      // CartDrawer.renderContents() only reads parsedState.id and
      // parsedState.sections — .id just gets stashed on the instance, so any
      // added variant id works here.
      var firstItem = (data.items && data.items[0]) || {};
      console.log('[bundle-upsell] calling drawer.renderContents()');
      drawer.renderContents({
        id: firstItem.variant_id || firstItem.id,
        sections: data.sections
      });
      return;
    }

    console.log('[bundle-upsell] no usable <cart-drawer> found — falling back to /cart redirect');
    // Fallback if cart-drawer isn't present on this page for some reason.
    window.location.href = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart'
      : '/cart';
  }

  function init() {
    var roots = document.querySelectorAll('[data-bundle-upsell]');
    console.log('[bundle-upsell] init() called — found', roots.length, 'root(s):', roots);
    roots.forEach(initBundleUpsell);
  }

  document.addEventListener('DOMContentLoaded', init);
  // Re-init after AJAX content swaps (matches your facets:updated pattern)
  document.addEventListener('facets:updated', init);
})();